<app-windowlist [model]="this">
    <!-- <div class="row p-1" *ngIf="list.length==0">
        <div class="col-lg-12">
            <div class="m-3">
                <i class="fa-2x fas fa-info text-info mr-3"></i>
                <small>
                    <i>In questa sezione puoi creare le Fasi di cui è composta la tua pratica. Per inserire una nuova Fase premi su&ensp;<i class="fas fa-plus"></i></i>
                </small>
            </div>
        </div>
    </div> -->
    <div class="card mt-2 mb-0">
            <div class="row p-1">
                <div class="col-4 col-lg-5">
                    <div class="input-group input-group-sm" >
                        <input type="text" name="table_search" class="form-control float-right" placeholder="Cerca..." [(ngModel)]="filter_search.value" (keyup.enter)="getItems()" [class.alert-info]="filter_search.value!=''">
                        <div class="input-group-append ">
                            <button type="submit" class="btn btn-default text-primary"  title="Avvia ricerca" (click)="getItems()"><i class="fas fa-search"></i></button>
                            <button class="btn btn-default text-danger" *ngIf="filter_search.value!=''"  title="Annulla ricerca" (click)="filter_search.value='';getItems();"><span id="searchclear" class="fas fa-times"></span></button>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <select class="form-control form-control-sm" [(ngModel)]="filter_id_type.value" (ngModelChange)="getItems()">
                        <option value="">Tutte le tipologie</option>
                        <option *ngFor="let t of type_dossier" [ngValue]="t.id">{{t.name}}</option>
                    </select>
                </div>
                <div class="col-4 col-lg-3" *ngIf="mode!='modal'">
                    <!-- <button  title="Cestina" *ngIf="filter_status.value == '1'" (click)="trash()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right ml-1 "><i class="far fa-trash-alt"></i></button>
                    <button  title="Elimina" *ngIf="filter_status.value == '2'" (click)="delete()" [disabled]="form.value.id.length == 0" class="btn btn-danger btn-xs float-right ml-1 "><i class="fas fa-trash"></i></button>
                    <button  title="Ripristina" *ngIf="filter_status.value == '2'" (click)="undo()" [disabled]="form.value.id.length == 0" class="btn btn-secondary btn-xs float-right ml-1 "><i class="fas fa-undo"></i></button>
                    <button  title="Esporta" (click)="export()" class="btn btn-warning btn-xs float-right ml-1 "><i class="fas fa-print"></i></button>
                    <button  title="Aggiungi" (click)="openDetail()" class="btn btn-success btn-xs float-right ml-1"><i class="fas fa-plus"></i></button> -->
                    <div class="pr-1">
                        <app-windowlistbuttons 
                            [model]="this"
                            [table]="'documents'" 
                            [funs]="[
                                        {'name':'Controlla campi','value':'verifyFields'}
                                    ]"
                            ></app-windowlistbuttons>
                    </div>
                   
                </div>
            </div>
            
            <div *ngIf="list==null" class="m-4">
                <i class="fa-2x fas fa-info text-info mr-3"></i>
                <i>Nessun elemento visualizzato in base ai filtri di ricerca impostati</i>
            </div>

            <form [formGroup]="form" *ngIf="list!=null">
                <!-- <div class=" m-4" *ngIf="list.length==0">
                    <i class="fa-2x fas fa-info text-info mr-3"></i>
                    <i>Nessun elemento presente!</i>
                </div> -->

                <table class="table table-sm table-head-fixed table-hover text-nowrap m-0" *ngIf="list.length>0">
                    <thead>
                        <tr>
                            <th>
                                 <div #checkboxselectall class="icheck-primary d-inline mr-3">
                                    <input type="checkbox" title="Seleziona tutti"
                                    (change)="onChangeAll($event.target.checked)" />
                                </div>ID
                            </th>
                            <th>                               
                                Titolo
                            </th>
                            <th class="d-none d-lg-table-cell">
                                Tipologia
                                <!-- <button type="button" class="btn btn-tool" (click)="switchOrdering('c.id_type')">
                                    <i class="fas fa-sort {{classOrdering('c.id_type')}}"  ></i>
                                </button> -->
                            </th>
                            <th class="text-center">Ordinamento</th>
                            <th></th>
                        </tr>
                    </thead>                    
                    <tbody>
                    
                        <!-- elemento ripetuto -->
                        <tr *ngFor="let record of list;let i=index">
                             <td>
                                <div class="icheck-primary d-inline mr-3">
                                    <input type="checkbox" #checkrecord id_record="{{record.id}}" title="ID: {{record.id}}"
                                    (change)="onChange(record.id, $event.target.checked)" [checked]="checkedAll" />
                                </div>
                                <small>{{record.id}}</small>
                            </td>
                            <td>                                
                                <b>{{record.title}}</b>
                            </td>
                            <td class="d-none d-lg-table-cell">
                                <small>{{record.type}}</small>
                            </td>
                            <td  class="text-center">
                                <span *ngIf="!record['show_ordering']" (dblclick)="record['show_ordering']=true">{{record.ordering}}</span>
                                <div class="input-group input-group-sm" *ngIf="record['show_ordering']">
                                    <input type="number" class="form-control form-control-sm" name="ordering_{{i}}" [(ngModel)]="record.ordering" style="max-width: 80px;">
                                    <div class="input-group-append input-group-append-sm">
                                        <button class="btn btn-sm btn-success" (click)="updateOrdering(record);record['show_ordering']=false"><i class="fa fa-check"></i></button>
                                        <button class="btn btn-sm btn-danger" (click)="record['show_ordering']=false"><i class="fa fa-times"></i></button>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button type="button" *ngIf="mode=='modal'" class="btn btn-secondary btn-xs float-right ml-1" (click)="selectRecord(record)">
                                    <span class="d-none d-sm-inline-block">Seleziona</span><i class="fas fa-chevron-right"></i></button>
                                    <button type="button" *ngIf="mode!='modal'" (click)="duplicate(record)"  title="Duplica" class="btn btn-info btn-xs float-right ml-1">
                                        <i class="fas fa-clone"></i></button>
                                <button type="button" *ngIf="mode!='modal'" (click)="openDetail(record)"  title="Modifica / Vedi" class="btn btn-secondary btn-xs float-right ml-1">
                                    <i class="fas fa-pencil-alt"></i></button>
                                <!-- <button type="button" *ngIf="mode!='modal'"  (click)="notify(record)" title="Notifica" class="btn btn-primary btn-xs float-right ml-1">
                                    <i class="far fa-paper-plane"></i></button> -->
                            </td>
                        </tr>

                    </tbody>
                </table>
            </form>
            
        <div class="card-footer clearfix py-1">
            <app-pagination [model]="this" ></app-pagination>
        </div>
    </div>
</app-windowlist>
